import { Button, Stack, Text } from '@mantine/core'
import { IconCalendar, IconCheck } from '@tabler/icons-react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

interface SuccessStepProps {
  selectedDate: Date
  selectedTime?: Date
  estimatedEndTime?: Date
  onClose: () => void
}

export function SuccessStep({
  selectedDate,
  selectedTime,
  estimatedEndTime,
  onClose,
}: SuccessStepProps) {
  const formattedDateTime = selectedTime
    ? dayjs(selectedTime).format('dddd, D. MMMM YYYY [klo] HH:mm')
    : dayjs(selectedDate).format('dddd, D. MMMM YYYY')

  const formattedEndTime = estimatedEndTime
    ? dayjs(estimatedEndTime).format('HH:mm')
    : null

  const handleAddToCalendar = () => {
    const start = selectedTime || selectedDate
    const end = estimatedEndTime || dayjs(start).add(1.5, 'hours').toDate()

    const formatUTCDate = (date: Date) =>
      dayjs(date).utc().format('YYYYMMDDTHHmmss') + 'Z'

    const uid = `${Date.now()}-${Math.random().toString(36).substring(7)}@markku.fi`

    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Markku//Booking Widget//FI
BEGIN:VEVENT
UID:${uid}
DTSTAMP:${formatUTCDate(new Date())}
DTSTART:${formatUTCDate(start)}
DTEND:${formatUTCDate(end)}
SUMMARY:Kartoituskäynti - Markku.fi
DESCRIPTION:Markku.fi kartoituskäynti
END:VEVENT
END:VCALENDAR`

    const blob = new Blob([icsContent], { type: 'text/calendar' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'kartoituskaynti.ics'
    link.click()
    URL.revokeObjectURL(url)
  }

  return (
    <Stack gap="md" align="center">
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: 'var(--mantine-color-green-1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconCheck size={48} color="var(--mantine-color-green-6)" />
      </div>

      <div style={{ textAlign: 'center' }}>
        <Text size="xl" fw={600} mb="xs">
          Varaus onnistui!
        </Text>
        <Text>Ilmainen kartoituskäyntisi on varattu</Text>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Text fw={500}>{formattedDateTime}</Text>
        {formattedEndTime && (
          <Text size="sm" c="dimmed" mt={4}>
            Arvioitu päättymisaika klo {formattedEndTime}
          </Text>
        )}
      </div>

      <Text ta="center" mt="xs">
        Otamme sinuun vielä yhteyttä ennen käyntiä.
      </Text>

      <Button
        onClick={handleAddToCalendar}
        size="md"
        fullWidth
        mt="md"
        leftSection={<IconCalendar size={18} />}
        variant="light"
      >
        Lisää kalenteriin
      </Button>

      <Button onClick={onClose} size="md" fullWidth variant="subtle">
        Sulje
      </Button>
    </Stack>
  )
}
